import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — three wide concrete entry steps rising 0.45 m toward +Z.
// Each step spans the full tile width along X, so tiles chain sideways into
// a wider stair; the top tread meets a porch or doorway on the +Z side.
const CONCRETE = "#9a9a94";
const CONCRETE_LIGHT = "#a8a8a2";

export const porchSteps = defineModel({
  id: "porch-steps",
  batchId: "modern",
  name: "Porch steps",
  tags: ["modern", "outdoor", "structure", "steps", "stairs", "entrance", "porch"],
  summary: "Three wide concrete entry steps rising 0.45 m toward +Z.",
  description:
    "A one-tile run of three concrete entry steps of the Modern Living kit, " +
    "rising 0.15 m each (0.45 m total) toward +Z, full tile width along X so " +
    "adjacent tiles chain into a wider entrance stair.",
  tiles: { w: 1, h: 1 },
  footprint: 0.9,
  parts(): Part[] {
    return [
      // bottom step (0 -> 0.15), full tile depth
      { geometry: new THREE.BoxGeometry(1.0, 0.15, 1.0), color: CONCRETE, position: [0, 0.075, 0] },
      // middle step (0.15 -> 0.3)
      { geometry: new THREE.BoxGeometry(1.0, 0.15, 0.667), color: CONCRETE_LIGHT, position: [0, 0.225, 0.1665] },
      // top step (0.3 -> 0.45)
      { geometry: new THREE.BoxGeometry(1.0, 0.15, 0.333), color: CONCRETE, position: [0, 0.375, 0.3335] },
    ];
  },
  animations: [],
});
